module.exports = __webpack_public_path__ + "static/media/image-card-3.06676e85.png";